document.addEventListener("DOMContentLoaded", () => {
  const wrapper = document.querySelector(".product-carousel .product-carousel-wrapper");
  const btnPrev = document.querySelector(".product-carousel-btn.prev");
  const btnNext = document.querySelector(".product-carousel-btn.next");
  const container = document.querySelector(".product-carousel-inner");

  if (!wrapper || !btnPrev || !btnNext || !container) return;

  const gap = 32;
  let originals = Array.from(wrapper.children);
  let slides = [];
  let logicalIndex = 0;

  const getVisible = () => {
    if (window.innerWidth <= 749) return 1;
    if (window.innerWidth <= 1024) return 2;
    if (window.innerWidth <= 1280) return 3;
    if (window.innerWidth <= 1920) return 4;
    if (window.innerWidth > 1920) return 5;
    return 4;
  };

  let v = getVisible();
  document.querySelector('.product-carousel').style.setProperty('--visible-slides', v);

  function disableFocus(el) {
    el.querySelectorAll("a, button, input, select, textarea").forEach(node => {
      node.setAttribute("tabindex", "-1");
      node.setAttribute("aria-hidden", "true");
    });
  }

  function cloneSlides() {
    wrapper.querySelectorAll(".clone").forEach(clone => clone.remove());

    if (originals.length > v) {
      originals.forEach((_, i) => {
        if (i >= originals.length - v) {
          const c = originals[i].cloneNode(true);
          c.classList.add("clone");
          disableFocus(c);
          wrapper.insertBefore(c, wrapper.firstChild);
        }
        if (i < v) {
          const c = originals[i].cloneNode(true);
          c.classList.add("clone");
          disableFocus(c);
          wrapper.appendChild(c);
        }
      });
    }
    slides = Array.from(wrapper.children);
  }

  function update() {
    if (originals.length <= v) {
      logicalIndex = 0;
      wrapper.style.transform = `translateX(0)`;
      slides.forEach((s, i) => {
        s.classList.toggle("visible", i < originals.length);
      });
      btnNext.disabled = true;
      btnPrev.disabled = true;
      return;
    }

    btnNext.disabled = false;
    btnPrev.disabled = false;

    if (logicalIndex < 0) logicalIndex = originals.length - 1;
    if (logicalIndex >= originals.length) logicalIndex = 0;

    const transformIndex = logicalIndex + v;
    const slideWidth = () => originals[0].offsetWidth + gap;

    wrapper.style.transform = `translateX(${-slideWidth() * transformIndex}px)`;
    slides.forEach((s, i) => {
      s.classList.toggle("visible", i >= transformIndex && i < transformIndex + v);
    });
  }

  function moveWithLoop(newIndex) {
    wrapper.classList.add("no-transition");
    logicalIndex = newIndex;
    update();
    requestAnimationFrame(() => {
      wrapper.classList.remove("no-transition");
      update();
    });
  }

  cloneSlides();
  update();

  btnNext.addEventListener("click", () => {
    if (originals.length <= v) return;
    logicalIndex++;
    if (logicalIndex >= originals.length) {
      moveWithLoop(0);
    } else {
      update();
    }
  });

  btnPrev.addEventListener("click", () => {
    if (originals.length <= v) return;
    logicalIndex--;
    if (logicalIndex < 0) {
      moveWithLoop(originals.length - 1);
    } else {
      update();
    }
  });

  // ---- Swipe/drag ----
  let isDragging = false;
  let startX = 0;
  const threshold = 30;

  wrapper.addEventListener("pointerdown", e => {
    // accettiamo solo touch sempre, e mouse solo se click su immagine/spazio vuoto
    const isTouch = e.pointerType === "touch";
    const isMouse = e.pointerType === "mouse";
    const target = e.target;

    const insideClickable = target.closest("a, button"); // blocca se click su link o button
    if (isMouse && insideClickable) return;

    if (isMouse && e.button !== 0) return; // solo tasto sinistro

    isDragging = true;
    startX = e.clientX;
    wrapper.setPointerCapture(e.pointerId);
    wrapper.style.cursor = "grabbing";
  });

  wrapper.addEventListener("pointerup", e => {
    if (!isDragging) return;
    isDragging = false;
    wrapper.style.cursor = "";
    const delta = e.clientX - startX;
    if (Math.abs(delta) < threshold) return; // era click normale
    if (delta < 0) {
      btnNext.click();
    } else {
      btnPrev.click();
    }
  });

  wrapper.addEventListener("pointercancel", () => {
    isDragging = false;
    wrapper.style.cursor = "";
  });

  window.addEventListener("resize", () => {
    v = getVisible();
    document.querySelector('.product-carousel').style.setProperty('--visible-slides', v);
    cloneSlides();
    logicalIndex = 0;
    update();
  });
});
